module.exports = __webpack_public_path__ + "static/media/show.2b804d95.svg";